const Currecy = (price) => {
    return new Intl.NumberFormat().format(price)
}

export default Currecy